import React, { FC } from 'react';
import FeaturesList from './features-list/FeaturesList';

const FeaturesSection: FC = () => {
	return <FeaturesList />;
};

export default FeaturesSection;